import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Users';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Users extends RpcClass{

    /**
     *  @class Users
     *  @alias module:src/server/com/silkplm/rpc/Users.Users
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param role {module:src/server/com/silkplm/model/users/Role.Role} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/NoOwnerException.NoOwnerException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/RoleIsAssignedException.RoleIsAssignedException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/RoleIsNotAvailableException.RoleIsNotAvailableException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     addRoleToUser(applicationUser, role) {
            return RpcClass.rpcCall('/rpc/users/add-role-to-user', [applicationUser, role]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param password {string} 
     * @param isEmailInvitationShouldBeSend {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/TooManyUsersException.TooManyUsersException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     addUser(applicationUser, password, isEmailInvitationShouldBeSend) {
            return RpcClass.rpcCall('/rpc/users/add-user', [applicationUser, password, isEmailInvitationShouldBeSend]);
    }
    /** 
     * @async
     * @param password {string} 
     * @param token {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/OrganizationDeletedException.OrganizationDeletedException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     changePasswordWithToken(password, token) {
            return RpcClass.rpcCallFixed('/rpc/users/change-password-with-token', [password, token]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param changedAssignedGroups {module:src/server/com/silkplm/model/users/Group.Group[]} 
     * @param changedAvailableGroups {module:src/server/com/silkplm/model/users/Group.Group[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     changeUserGroup(applicationUser, changedAssignedGroups, changedAvailableGroups) {
            return RpcClass.rpcCall('/rpc/users/change-user-group', [applicationUser, changedAssignedGroups, changedAvailableGroups]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param changedAssignedRoles {module:src/server/com/silkplm/model/users/Role.Role[]} 
     * @param changedAvailableRoles {module:src/server/com/silkplm/model/users/Role.Role[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException.LastOwnerCannotBeDeletedException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/NoOwnerException.NoOwnerException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     changeUserRole(applicationUser, changedAssignedRoles, changedAvailableRoles) {
            return RpcClass.rpcCall('/rpc/users/change-user-role', [applicationUser, changedAssignedRoles, changedAvailableRoles]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     checkIfSessionUserHasMerchantRole() {
            return RpcClass.rpcCall('/rpc/users/check-if-session-user-has-merchant-role', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     checkIfSessionUserHasPMRole() {
            return RpcClass.rpcCall('/rpc/users/check-if-session-user-has-p-m-role', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/TooManyUsersException.TooManyUsersException}
     * @returns {Promise<*>}
     */
     checkLimitUsersInOrganization() {
            return RpcClass.rpcCall('/rpc/users/check-limit-users-in-organization', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteProfileImageOnMyAccount() {
            return RpcClass.rpcCall('/rpc/users/delete-profile-image-on-my-account', []);
    }
    /** 
     * @async
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteProfileImageOnUser(userId) {
            return RpcClass.rpcCall('/rpc/users/delete-profile-image-on-user', [userId]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param role {module:src/server/com/silkplm/model/users/Role.Role} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException.LastOwnerCannotBeDeletedException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/NoOwnerException.NoOwnerException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/RoleIsAssignedException.RoleIsAssignedException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/RoleIsNotAvailableException.RoleIsNotAvailableException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     deleteRoleFromUser(applicationUser, role) {
            return RpcClass.rpcCall('/rpc/users/delete-role-from-user', [applicationUser, role]);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException.LastOwnerCannotBeDeletedException}
     * @throws {module:src/server/com/silkplm/rpc/exceptions/UserCannotBeDeletedException.UserCannotBeDeletedException}
     * @returns {Promise<*>}
     */
     deleteUser(id) {
            return RpcClass.rpcCall('/rpc/users/delete-user', [id]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     editExistingUser(applicationUser, password) {
            return RpcClass.rpcCall('/rpc/users/edit-existing-user', [applicationUser, password]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     editMyAccount(applicationUser, password) {
            return RpcClass.rpcCall('/rpc/users/edit-my-account', [applicationUser, password]);
    }
    /** 
     * @async
     * @param newPassword {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     editMyPassword(newPassword) {
            return RpcClass.rpcCall('/rpc/users/edit-my-password', [newPassword]);
    }
    /** 
     * @async
     * @param organization {string} 
     * @param email {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     forgotPassword(organization, email) {
            return RpcClass.rpcCall('/rpc/users/forgot-password', [organization, email]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, number>>}
     */
     getCounterDataForViews() {
            return RpcClass.rpcCall('/rpc/users/get-counter-data-for-views', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     getLimitOfUsersInOrganization() {
            return RpcClass.rpcCall('/rpc/users/get-limit-of-users-in-organization', []);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     getSelectedUserInfo(id) {
            return RpcClass.rpcCall('/rpc/users/get-selected-user-info', [id]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     getSessionUserInfo() {
            return RpcClass.rpcCall('/rpc/users/get-session-user-info', []);
    }
    /** 
     * @async
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     isPasswordIsDifferent(password) {
            return RpcClass.rpcCall('/rpc/users/is-password-is-different', [password]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Group.Group[]>}
     */
     listAllGroups() {
            return RpcClass.rpcCall('/rpc/users/list-all-groups', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role[]>}
     */
     listAllRoles() {
            return RpcClass.rpcCall('/rpc/users/list-all-roles', []);
    }
    /** 
     * @async
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number[]>}
     */
     listAssignedAdvancedPermissions(userId) {
            return RpcClass.rpcCall('/rpc/users/list-assigned-advanced-permissions', [userId]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Group.Group[]>}
     */
     listAssignedGroups(applicationUser) {
            return RpcClass.rpcCall('/rpc/users/list-assigned-groups', [applicationUser]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role[]>}
     */
     listAssignedRoles(applicationUser) {
            return RpcClass.rpcCall('/rpc/users/list-assigned-roles', [applicationUser]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Group.Group[]>}
     */
     listAvailableGroups(applicationUser) {
            return RpcClass.rpcCall('/rpc/users/list-available-groups', [applicationUser]);
    }
    /** 
     * @async
     * @param applicationUser {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role[]>}
     */
     listAvailableRoles(applicationUser) {
            return RpcClass.rpcCall('/rpc/users/list-available-roles', [applicationUser]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser[]>}
     */
     listUsers() {
            return RpcClass.rpcCall('/rpc/users/list-users', []);
    }
    /** 
     * @async
     * @param userId {string} 
     * @param files {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]>}
     */
     saveAttachments(userId, files) {
            return RpcClass.rpcCall('/rpc/users/save-attachments', [userId, files]);
    }
    /** 
     * @async
     * @param fileInRepository {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     saveProfileImageOnMyAccount(fileInRepository) {
            return RpcClass.rpcCall('/rpc/users/save-profile-image-on-my-account', [fileInRepository]);
    }
    /** 
     * @async
     * @param userId {string} 
     * @param fileInRepository {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     saveProfileImageOnUser(userId, fileInRepository) {
            return RpcClass.rpcCall('/rpc/users/save-profile-image-on-user', [userId, fileInRepository]);
    }
    /** 
     * @async
     * @param file {File} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository>}
     */
     uploadImage(file) {
            return RpcClass.rpcCallMultipart('/rpc/users/upload-image', [file]);
    }
    /** 
     * @async
     * @param email {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateEmail(email) {
            return RpcClass.rpcCall('/rpc/users/validate-email', [email]);
    }
    /** 
     * @async
     * @param email {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateEmailForNewUser(email) {
            return RpcClass.rpcCall('/rpc/users/validate-email-for-new-user', [email]);
    }
    /** 
     * @async
     * @param email {string} 
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateEmailForUser(email, userId) {
            return RpcClass.rpcCall('/rpc/users/validate-email-for-user', [email, userId]);
    }
    /** 
     * @async
     * @param login {string} 
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateLogin(login, userId) {
            return RpcClass.rpcCall('/rpc/users/validate-login', [login, userId]);
    }
    /** 
     * @async
     * @param token {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser>}
     */
     verifyToken(token) {
            return RpcClass.rpcCall('/rpc/users/verify-token', [token]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Users';
metadata.__type_short__ = 'Users';
Users.prototype.__metadata__ = metadata;

Users.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Users */
export default Users

export { Users }
